import React, { useState, useEffect, useCallback } from 'react';
import './ListView.css';
import { secureFetch } from '../utils/secureApi';

// Create a map of countries and cities
const countryMap = new Map();
const rawData = `Country;City
🇫🇷  France;Paris
🇫🇷  France;Nice
🇫🇷  France;Marseille
🇬🇧  United Kingdom;London
🇬🇧  United Kingdom;Edinburgh
🇬🇧  United Kingdom;Manchester
🇮🇹  Italy;Rome
🇮🇹  Italy;Venice
🇮🇹  Italy;Florence
🇩🇪  Germany;Berlin
🇩🇪  Germany;Munich
🇩🇪  Germany;Frankfurt
🇪🇸  Spain;Barcelona
🇪🇸  Spain;Madrid
🇪🇸  Spain;Valencia
🇳🇱  Netherlands;Amsterdam
🇳🇱  Netherlands;Rotterdam
🇦🇹  Austria;Vienna
🇨🇭  Switzerland;Zurich
🇨🇭  Switzerland;Geneva
🇧🇪  Belgium;Brussels
🇧🇪  Belgium;Antwerp
🇵🇹  Portugal;Lisbon
🇵🇹  Portugal;Porto
🇬🇷  Greece;Athens
🇬🇷  Greece;Thessaloniki
🇳🇴  Norway;Oslo
🇸🇪  Sweden;Stockholm
🇸🇪  Sweden;Gothenburg
🇩🇰  Denmark;Copenhagen
🇫🇮  Finland;Helsinki
🇵🇱  Poland;Warsaw
🇵🇱  Poland;Krakow
🇭🇺  Hungary;Budapest
🇨🇿  Czech Republic;Prague
🇸🇰  Slovakia;Bratislava
🇭🇷  Croatia;Zagreb
🇸🇮  Slovenia;Ljubljana
🇧🇬  Bulgaria;Sofia
🇷🇴  Romania;Bucharest
🇷🇸  Serbia;Belgrade
🇲🇪  Montenegro;Podgorica
🇧🇦  Bosnia & Herzegovina;Sarajevo
🇦🇱  Albania;Tirana
🇲🇰  North Macedonia;Skopje
🇲🇩  Moldova;Chisinau
🇺🇦  Ukraine;Kyiv
🇺🇦  Ukraine;Lviv
🇧🇾  Belarus;Minsk
🇷🇺  Russia;Moscow
🇷🇺  Russia;Saint Petersburg
🇱🇻  Latvia;Riga
🇱🇹  Lithuania;Vilnius
🇪🇪  Estonia;Tallinn
🇮🇸  Iceland;Reykjavik
🇮🇪  Ireland;Dublin
🇮🇪  Ireland;Cork
🇱🇺  Luxembourg;Luxembourg City
🇲🇨  Monaco;Monaco
🇲🇹  Malta;Valletta
🇦🇩  Andorra;Andorra la Vella
🇸🇲  San Marino;San Marino
🇱🇮  Liechtenstein;Vaduz
🇽🇰  Kosovo;Pristina
🇦🇲  Armenia;Yerevan
🇬🇪  Georgia;Tbilisi
🇦🇿  Azerbaijan;Baku
🇨🇾  Cyprus;Nicosia
🇳🇴  Norway;Bergen
🇨🇭  Switzerland;Bern
🇩🇪  Germany;Hamburg
🇩🇪  Germany;Cologne
🇫🇷  France;Lyon
🇫🇷  France;Bordeaux
🇮🇹  Italy;Naples
🇮🇹  Italy;Milan
🇪🇸  Spain;Seville
🇪🇸  Spain;Granada
🇵🇹  Portugal;Faro
🇳🇱  Netherlands;Utrecht
🇬🇧  United Kingdom;Birmingham
🇬🇧  United Kingdom;Liverpool
🇧🇪  Belgium;Ghent
🇧🇪  Belgium;Bruges
🇵🇱  Poland;Gdansk
🇵🇱  Poland;Wroclaw
🇭🇺  Hungary;Debrecen
🇨🇿  Czech Republic;Brno
🇧🇬  Bulgaria;Plovdiv
🇷🇴  Romania;Cluj-Napoca
🇭🇷  Croatia;Dubrovnik
🇧🇦  Bosnia & Herzegovina;Mostar
🇺🇦  Ukraine;Odessa
🇷🇸  Serbia;Novi Sad
🇷🇺  Russia;Kazan
🇪🇪  Estonia;Tartu
🇮🇪  Ireland;Galway
🇦🇹  Austria;Salzburg
🇸🇪  Sweden;Malmö
🇳🇴  Norway;Stavanger
🇹🇷  Turkey;Istanbul
🇹🇷  Turkey;Ankara
🇹🇷  Turkey;Izmir
🇹🇷  Turkey;Antalya
🇹🇷  Turkey;Bursa
🇹🇷  Turkey;Adana
🇹🇷  Turkey;Gaziantep
🇹🇷  Turkey;Konya
🇹🇷  Turkey;Trabzon
🇹🇷  Turkey;Kayseri
🇹🇷  Turkey;Samsun
🇹🇷  Turkey;Eskişehir
🇹🇷  Turkey;Diyarbakır
🇹🇷  Turkey;Mersin`;

rawData.split('\n').slice(1).forEach(line => {
  const [country, city] = line.split(';');
  if (!countryMap.has(country)) {
    countryMap.set(country, []);
  }
  countryMap.get(country).push(city);
});

const ComingSoon = () => (
  <div className="coming-soon-container">
    <div className="coming-soon-text">Coming Soon</div>
    <div className="coming-soon-subtext">We're working on bringing great restaurants to this area!</div>
    <div className="coming-soon-animation">
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </div>
  </div>
);

const ListView = () => {
  const [restaurants, setRestaurants] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    venue_type: '',
    cuisines_label: '',
    country: '🇹🇷  Turkey',
    city: 'Istanbul',
  });

  const pageSize = 10;

  const clearData = () => {
    setRestaurants(null);
    setLoading(true);
    setError(null);
  };

  const fetchRestaurants = useCallback(async (page) => {
    if (!filters.country || !filters.city) {
      setError('Please select both country and city');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await secureFetch('/.netlify/functions/restaurant-list', {
        method: 'POST',
        body: JSON.stringify({
          body: {
            page,
            pageSize,
            venue_type: filters.venue_type,
            cuisines_label: filters.cuisines_label,
            country: filters.country,
            city: filters.city
          }
        }),
      });

      setRestaurants(data);
      setHasMore(data.length >= pageSize);
    } catch (error) {
      console.error('Error fetching restaurants:', error);
      setError('Failed to fetch restaurants. Please try again later.');
    }
    setLoading(false);
  }, [filters]);

  useEffect(() => {
    clearData();
    if (filters.country && filters.city) {
      setCurrentPage(1);
      fetchRestaurants(1);
    }
  }, [filters, fetchRestaurants]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    clearData();
    
    setFilters(prev => {
      if (name === 'country') {
        const cities = countryMap.get(value) || [];
        return {
          ...prev,
          country: value,
          city: cities[0] || ''
        };
      }
      return { ...prev, [name]: value };
    });
    setSearchTerm('');
    setCurrentPage(1);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!filters.country || !filters.city) {
      setError('Please select both country and city before searching');
      return;
    }

    clearData();
    
    try {
      if (!searchTerm) {
        setCurrentPage(1);
        return fetchRestaurants(1);
      }

      const data = await secureFetch('/.netlify/functions/search-restaurants', {
        method: 'POST',
        body: JSON.stringify({
          body: {
            search: searchTerm,
            venue_type: filters.venue_type,
            cuisines_label: filters.cuisines_label,
            country: filters.country,
            city: filters.city
          }
        }),
      });

      setRestaurants(data);
      setHasMore(false);
      setCurrentPage(1);
    } catch (error) {
      console.error('Error searching restaurants:', error);
      setError('Failed to search restaurants. Please try again later.');
    }
    setLoading(false);
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    setCurrentPage(newPage);
    fetchRestaurants(newPage);
    // Scroll to top of the list when changing pages
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="listview-wrapper">
      <div className="listview-content">
        <form onSubmit={handleSearch} className="search-container">
          <input
            type="text"
            placeholder="Search restaurant names..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="spotlight-search"
          />
          <button type="submit" className="search-button">Search</button>
        </form>

        <div className="filters-container">
          <select name="venue_type" onChange={handleFilterChange} value={filters.venue_type}>
            <option value="">All Venue Types</option>
            <option value="cafe">Cafe</option>
            <option value="restaurant">Restaurant</option>
            <option value="bar">Bar</option>
          </select>
          <select name="cuisines_label" onChange={handleFilterChange} value={filters.cuisines_label}>
            <option value="">All Cuisines</option>
            <option value="Türk Mutfağı">Türk Mutfağı</option>
            <option value="İtalyan Mutfağı">İtalyan Mutfağı</option>
            <option value="Deniz Ürünleri">Deniz Ürünleri</option>
          </select>
          <select 
            name="country" 
            onChange={handleFilterChange} 
            value={filters.country}
            required
          >
            <option value="">Select Country</option>
            {Array.from(countryMap.keys()).map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
          <select 
            name="city" 
            onChange={handleFilterChange} 
            value={filters.city}
            required
            disabled={!filters.country}
          >
            <option value="">Select City</option>
            {filters.country && countryMap.get(filters.country).map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>

        {loading ? (
          <div className="loading">Loading...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : restaurants && restaurants.length > 0 ? (
          <>
            <div className="card-container">
              {restaurants.map((restaurant) => (
                <div className={`venue-card ${restaurant.venue_type}`} key={restaurant._id}>
                  <div className="logo">{restaurant.restaurant_name}</div>
                  <div className="venue-details">
                    <p className="venue-address">{restaurant.street_value}</p>
                    <p>Type: {restaurant.venue_type}</p>
                    <p>Cuisine: {restaurant.cuisines_label}</p>
                    <p>Price: {restaurant.price_category}</p>
                    <p>City: {restaurant.cityname}</p>
                  </div>
                  <div className="button-container">
                    {restaurant.menu_url && (
                      <a href={restaurant.menu_url} target="_blank" rel="noopener noreferrer">View Menu</a>
                    )}
                    <a 
                      href={`https://www.google.com/maps/dir/?api=1&destination=${restaurant.lat_value},${restaurant.lon_value}`} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="directions-icon"
                    >
                      ╰┈➤
                    </a>
                  </div>
                </div>
              ))}
            </div>
            
            {!searchTerm && (
              <div className="pagination-controls">
                <button 
                  onClick={() => handlePageChange(currentPage - 1)} 
                  disabled={currentPage === 1 || loading}
                  className="pagination-button"
                >
                  Previous Page
                </button>
                <span className="page-indicator">
                  Page {currentPage}
                </span>
                {hasMore && (
                  <button 
                    onClick={() => handlePageChange(currentPage + 1)} 
                    disabled={loading}
                    className="pagination-button"
                  >
                    Next Page
                  </button>
                )}
              </div>
            )}

            <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '14px', color: '#666' }}>
              Showing {restaurants.length} restaurants | Page {currentPage}
            </div>
          </>
        ) : (
          <ComingSoon />
        )}
      </div>
    </div>
  );
};

export default ListView;